import Appsignal from "@appsignal/javascript";
import { plugin as WindowEventsPlugin } from "@appsignal/plugin-window-events";
import { plugin as BreadcrumbsConsolePlugin } from "@appsignal/plugin-breadcrumbs-console";
import Config from "../app/config/Config";
import AppModel from "../app/core/AppModel";

export default class AppSignalService {
    /**
     * @constructor
     * @param {Config} config 
     * @param {AppModel} appModel 
     */
    constructor(config, appModel) {
        this._config = config;
        this._appModel = appModel;

        /** @type {Appsignal} */
        this._appSignalClient = null;
    }

    connect() {
        return new Promise((resolve, _) => {
            if (this._appSignalClient) {
                console.warn(`AppSignalService.connect - the AppSignal client is already initialized.`);

                resolve();
                return;
            }

            const version = this._config.getValue(Config.VERSION);
            const commitHash = this._config.getValue(Config.COMMIT_HASH);

            const versionStr = `${version} (${commitHash})`;

            this._appSignalClient = new Appsignal({
                key: "DEFINE.APP_SIGNAL_FRONTEND_ERROR_MONITORING_KEY", // set via GitLab CI
                revision: versionStr,
            });

            // AppSignal doesn't track unhandled exceptions by default.
            // This plugin enables unhandled exceptions tracking.
            // For more information see: https://docs.appsignal.com/front-end/plugins/plugin-window-events.html
            this._appSignalClient.use(WindowEventsPlugin());

            // This plugin decorates errors with console history (e.g. logs, warns...)
            // For more information see: https://docs.appsignal.com/front-end/plugins/plugin-breadcrumbs-console.html
            this._appSignalClient.use(BreadcrumbsConsolePlugin());

            this.addDefaultDecorators();

            resolve();
        });
    }

    addDefaultDecorators() {
        const appId = this._config.getValue(Config.APPID);
        const version = this._config.getValue(Config.VERSION);
        const commitHash = this._config.getValue(Config.COMMIT_HASH);
        const environment = this._appModel.environment;
        const language = this._appModel.language;

        this._appSignalClient.addDecorator((span) => {
            return span.setTags({
                app_id: appId,
                version,
                commit_hash: commitHash,
                environment,
                language,
            });
        });
    }
}